import React, { Component } from 'react';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { buildPath } from 'utils/commonUtils';

import { isLoadingByArticleId, loadByArticleId } from 'modules/Common/reducers/article';
import { setLayout } from 'modules/Common/reducers/layout';
import { loadRidesForArticle } from 'modules/HorseRacing/reducers/rides';
import { loadMediaForArticles } from 'modules/Common/reducers/media';
import { RightColumn } from "../../Common/pages/RightColumn";
import { StandardPage } from "../../Common/pages/StandardPage";
import PropTypes from "prop-types";

export class ArticleContainer extends Component {
  static propTypes = {
    Article: PropTypes.element.isRequired,
    MostReadFootball: PropTypes.element,
    MostReadAll: PropTypes.element,
    MostReadRacing: PropTypes.element,
    location: PropTypes.object.isRequired,
    route: PropTypes.shape({
      rightHandContent: PropTypes.arrayOf(PropTypes.string).isRequired,
      sport: PropTypes.string.isRequired
    }).isRequired
  };

  render() {
    // most read articles passed in from respective routers
    const {
      location,
      Article,
      MostReadFootball,
      MostReadAll,
      MostReadRacing,
      route
    } = this.props;

    const mostRead = MostReadRacing || MostReadFootball || MostReadAll;

    return (
      <StandardPage sport={route.sport} title="Article" >
        <div className="main-layout-left-column">
          {Article}
          {mostRead &&
            <div className="main-layout-block main-layout-hide-desktop last-handheld">
              {mostRead}
            </div>
          }
        </div>

        <RightColumn location={location}
                     sport={route.sport}
                     content={route.rightHandContent} />
      </StandardPage>
    )
  }
}

function setLayoutForArticle(dispatch, routes, result) {
  const {
    sensitive: sensitiveArticle = false
  } = result;

  const path = buildPath(routes);
  if (sensitiveArticle) {
    dispatch(setLayout(path, 'sensitive'));
  } else {
    dispatch(setLayout(path, 'nonSensitive'));
  }
}

export default standardAsyncConnect([
  {
    dispatch: ({state, params: {articleId}}) => loadByArticleId(state, articleId),
    preventResolve: ({state, params: {articleId}}) => isLoadingByArticleId(state, articleId),
    then: ({dispatch, state, routes, result}) => {
      setLayoutForArticle(dispatch, routes, result);
      return Promise.all([
        loadRidesForArticle(state, dispatch, result),
        loadMediaForArticles(state, dispatch, [result])
      ]);
    },
    state: state => ({ layout: state.common.layout })
  }
])(catchLifeCycleErrors(ArticleContainer))



// WEBPACK FOOTER //
// ./modules/News/containers/ArticleContainer.js